export const visit = (vm, at) => {
at({ "nl": { "conversationsVisitorUIAvailability": { "sameDay": "We zijn er vandaag weer om {{time}}", "nextDay": "We zijn er morgen om {{time}} weer", "nextWeek": "We zijn er {{dayOfWeek}} weer om {{time}}" } } });
};